import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UnitOfMeasureDto, UnitOfMeasureWrite } from '../models/unit-of-measure-dto';

@Injectable({ providedIn: 'root' })
export class UnitOfMeasureService {
  constructor(private httpClient: HttpClient) {}

  get(): Observable<UnitOfMeasureDto[]> {
    return this.httpClient.get<UnitOfMeasureDto[]>(`${environment.backendUrl}/api/v1/unit-of-measure`);
  }

  getById(id: number): Observable<UnitOfMeasureDto> {
    return this.httpClient.get<UnitOfMeasureDto>(`${environment.backendUrl}/api/v1/unit-of-measure/${id}`);
  }

  create(data: UnitOfMeasureWrite): Observable<UnitOfMeasureDto> {
    return this.httpClient.post<UnitOfMeasureDto>(`${environment.backendUrl}/api/admin/v1/unit-of-measure`, data);
  }

  update(id: number, data: UnitOfMeasureWrite): Observable<UnitOfMeasureDto> {
    return this.httpClient.put<UnitOfMeasureDto>(`${environment.backendUrl}/api/admin/v1/unit-of-measure/${id}`, data);
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${environment.backendUrl}/api/admin/v1/unit-of-measure/${id}`);
  }
}
